import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import { invert } from '../../utils/protoutil';
import type { MaybeError } from '../base/base-mutation';
import type { IValidSetThemeMutationData } from '../base/valid-mutation-data';
import type { PresentationDataModel } from '../../model/presentation-data-model';

export class SetThemeMutation extends BaseMutation<PresentationDataModel, IValidSetThemeMutationData> {
    public readonly type: MutationType = MutationType.SetTheme;

    public apply(presentation: PresentationDataModel) {
        const { themeId, themeName, themeElements } = this.data;
        presentation.store.setThemeById(themeId, themeName, themeElements);
    }

    public invert(presentation: PresentationDataModel): [IValidSetThemeMutationData] {
        const { themeId, themeName, themeElements } = this.data;
        const theme = presentation.store.getThemeById(themeId);
        assert(theme, 'theme should exist');

        const mutData: IValidSetThemeMutationData = {
            type: MutationType.SetTheme,
            themeId,
            ...invert(
                {
                    themeName: theme?.store.data.name || '',
                    themeElements: theme?.store.data.themeElements || {},
                },
                {
                    themeName,
                    themeElements,
                },
                { themeElements: true },
            ),
        };
        return [mutData];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { themeId } = this.data;
        return Rule.theme.should.existInPresentation(presentation, themeId);
    }
}
